import {
  DEVICE_TYPE_API, EMPLOYEE_TYPE_API, LICENSE_API,
  COMPANY_API, VENDOR_API, EMPLOYEE_API, SERVICE_ESTIMATE_RATE_API,
  SERVICE_CATEGORY_API, USER_API, SERVICE_API, MASTER_API,
  COMPANY_SERVICE_FIXED_CHARGE_API, INVOICE_API, SMTP_SETTINGS_API,
  COMPANY_EMPLOYEE_API,
  REPORT_API,
  PERMISSION_API,
  ACCOUNT_API,
} from "./apiEndpoints";
import http from "./http";

const REQUEST_TEMPLATES = (endpoint: string) => ({
  getWithParameters: (params: any) => http.get(endpoint, { params }),
  create: (payload?: any, query?: string) => http.post(`${endpoint}${query ? `?${query}` : ''}`, payload),
  getById: (id: string, entity?: string) => http.get(`${endpoint}/${id}${entity ? `/${entity}` : ''}`),
  modify: (id: string, payload: any, entity: string = '') => http.patch(`${endpoint}/${id}/${entity}`, payload),
  getAll: () => http.get(endpoint),
  delete: (id: string) => http.delete(`${endpoint}/${id}`),
  update: (id: string, payload: string) => http.put(`${endpoint}/${id}`, payload),
  createById:(id: string, payload: any, entity: string = '') => http.post(`${endpoint}/${id}${entity ? `/${entity}` : ''}`, payload),
  uploadFile: (id: string, payload: string) => http.put(`${endpoint}/${id}`, payload),
  downloadFile: (params: any) => http.get(endpoint, { params, responseType: 'arraybuffer' }),
});

export const User = {
  list: REQUEST_TEMPLATES(USER_API.LIST).create,
  create: REQUEST_TEMPLATES(USER_API.USERS).create,
  delete: REQUEST_TEMPLATES(USER_API.USERS).delete,
  update: REQUEST_TEMPLATES(USER_API.USERS).update,
  details: REQUEST_TEMPLATES(USER_API.USERS).getById,
  changePassword: REQUEST_TEMPLATES(USER_API.CHANGE_PASSWORD).create,
  forgotPassword: REQUEST_TEMPLATES(USER_API.FORGOT_PASSWORD).create,
  resetPassword: REQUEST_TEMPLATES(USER_API.RESET_PASSWORD).create,
  userPermissions: REQUEST_TEMPLATES(USER_API.USERS).createById,
};
export const Company = {
  list: REQUEST_TEMPLATES(COMPANY_API.LIST).create,
  create: REQUEST_TEMPLATES(COMPANY_API.COMPANY).create,
  delete: REQUEST_TEMPLATES(COMPANY_API.COMPANY).delete,
  update: REQUEST_TEMPLATES(COMPANY_API.COMPANY).update,
  details: REQUEST_TEMPLATES(COMPANY_API.COMPANY).getById,
  updateStats: REQUEST_TEMPLATES(COMPANY_API.COMPANY).createById,
};
export const CompanyEmployee = {
  assign: REQUEST_TEMPLATES(COMPANY_EMPLOYEE_API.ASSIGN).create,
  assignedList: REQUEST_TEMPLATES(COMPANY_EMPLOYEE_API.EMPLOYEES).createById,
  assignEndDate: REQUEST_TEMPLATES(COMPANY_EMPLOYEE_API.SERVICE_END).create,
  delete: REQUEST_TEMPLATES(COMPANY_EMPLOYEE_API.COMPANY_EMPLOYEE).delete,
  details: REQUEST_TEMPLATES(COMPANY_EMPLOYEE_API.COMPANY_EMPLOYEE).getById,
  update: REQUEST_TEMPLATES(COMPANY_EMPLOYEE_API.COMPANY_EMPLOYEE).update,
};
export const Employee = {
  list: REQUEST_TEMPLATES(EMPLOYEE_API.LIST).create,
  create: REQUEST_TEMPLATES(EMPLOYEE_API.EMPLOYEE).create,
  delete: REQUEST_TEMPLATES(EMPLOYEE_API.EMPLOYEE).delete,
  update: REQUEST_TEMPLATES(EMPLOYEE_API.EMPLOYEE).update,
  details: REQUEST_TEMPLATES(EMPLOYEE_API.EMPLOYEE).getById,
};
export const Vendor = {
  list: REQUEST_TEMPLATES(VENDOR_API.LIST).create,
  create: REQUEST_TEMPLATES(VENDOR_API.VENDOR).create,
  delete: REQUEST_TEMPLATES(VENDOR_API.VENDOR).delete,
  update: REQUEST_TEMPLATES(VENDOR_API.VENDOR).update,
  details: REQUEST_TEMPLATES(VENDOR_API.VENDOR).getById,
};
export const Service = {
  list: REQUEST_TEMPLATES(SERVICE_API.LIST).create,
  create: REQUEST_TEMPLATES(SERVICE_API.SERVICE).create,
  delete: REQUEST_TEMPLATES(SERVICE_API.SERVICE).delete,
  update: REQUEST_TEMPLATES(SERVICE_API.SERVICE).update,
  details: REQUEST_TEMPLATES(SERVICE_API.SERVICE).getById,
};
export const EstimatedRate = {
  list: REQUEST_TEMPLATES(SERVICE_ESTIMATE_RATE_API.LIST).create,
  create: REQUEST_TEMPLATES(SERVICE_ESTIMATE_RATE_API.SERVICE_ESTIMATE_RATE).create,
  delete: REQUEST_TEMPLATES(SERVICE_ESTIMATE_RATE_API.SERVICE_ESTIMATE_RATE).delete,
  update: REQUEST_TEMPLATES(SERVICE_ESTIMATE_RATE_API.SERVICE_ESTIMATE_RATE).update,
  details: REQUEST_TEMPLATES(SERVICE_ESTIMATE_RATE_API.SERVICE_ESTIMATE_RATE).getById,
};
export const FixedCharge = {
  list: REQUEST_TEMPLATES(COMPANY_SERVICE_FIXED_CHARGE_API.LIST).create,
  create: REQUEST_TEMPLATES(COMPANY_SERVICE_FIXED_CHARGE_API.COMPANY_SERVICE_FIXED_CHARGE).create,
  delete: REQUEST_TEMPLATES(COMPANY_SERVICE_FIXED_CHARGE_API.COMPANY_SERVICE_FIXED_CHARGE).delete,
  update: REQUEST_TEMPLATES(COMPANY_SERVICE_FIXED_CHARGE_API.COMPANY_SERVICE_FIXED_CHARGE).update,
  details: REQUEST_TEMPLATES(COMPANY_SERVICE_FIXED_CHARGE_API.COMPANY_SERVICE_FIXED_CHARGE).getById,
};
export const Invoice = {
  list: REQUEST_TEMPLATES(INVOICE_API.LIST).create,
  create: REQUEST_TEMPLATES(INVOICE_API.INVOICE).create,
  delete: REQUEST_TEMPLATES(INVOICE_API.INVOICE).delete,
  update: REQUEST_TEMPLATES(INVOICE_API.INVOICE).update,
  details: REQUEST_TEMPLATES(INVOICE_API.INVOICE).getById,
  uploadFile: REQUEST_TEMPLATES(INVOICE_API.INVOICE).uploadFile,
};
export const Master = {
  financialYearList: REQUEST_TEMPLATES(MASTER_API.FINANCIAL_YEAR_LIST).create,
}

export const ServiceCategory = {
  list: REQUEST_TEMPLATES(SERVICE_CATEGORY_API.LIST).create,
  create: REQUEST_TEMPLATES(SERVICE_CATEGORY_API.SERVICE_CATEGORY).create,
  update: REQUEST_TEMPLATES(SERVICE_CATEGORY_API.SERVICE_CATEGORY).update,
  delete: REQUEST_TEMPLATES(SERVICE_CATEGORY_API.SERVICE_CATEGORY).delete,
  details: REQUEST_TEMPLATES(SERVICE_CATEGORY_API.SERVICE_CATEGORY).getById,
};
export const EmployeeType = {
  list: REQUEST_TEMPLATES(EMPLOYEE_TYPE_API.LIST).create,
  create: REQUEST_TEMPLATES(EMPLOYEE_TYPE_API.EMPLOYEE_TYPE).create,
  update: REQUEST_TEMPLATES(EMPLOYEE_TYPE_API.EMPLOYEE_TYPE).update,
  delete: REQUEST_TEMPLATES(EMPLOYEE_TYPE_API.EMPLOYEE_TYPE).delete,
  details: REQUEST_TEMPLATES(EMPLOYEE_TYPE_API.EMPLOYEE_TYPE).getById,
};
export const DeviceType = {
  list: REQUEST_TEMPLATES(DEVICE_TYPE_API.LIST).create,
  create: REQUEST_TEMPLATES(DEVICE_TYPE_API.DEVICE_TYPE).create,
  update: REQUEST_TEMPLATES(DEVICE_TYPE_API.DEVICE_TYPE).update,
  delete: REQUEST_TEMPLATES(DEVICE_TYPE_API.DEVICE_TYPE).delete,
  details: REQUEST_TEMPLATES(DEVICE_TYPE_API.DEVICE_TYPE).getById,
};
export const License = {
  list: REQUEST_TEMPLATES(LICENSE_API.LIST).create,
  create: REQUEST_TEMPLATES(LICENSE_API.LICENSE).create,
  update: REQUEST_TEMPLATES(LICENSE_API.LICENSE).update,
  delete: REQUEST_TEMPLATES(LICENSE_API.LICENSE).delete,
  details: REQUEST_TEMPLATES(LICENSE_API.LICENSE).getById,
};

export const SmtpSettings = {
  create: REQUEST_TEMPLATES(SMTP_SETTINGS_API.SMTP_SETTINGS).create,
  details: REQUEST_TEMPLATES(SMTP_SETTINGS_API.SMTP_SETTINGS).getAll,
};

export const Report = {
  licenseToCompanyList: REQUEST_TEMPLATES(REPORT_API.LICENSE_TO_COMPANY).getWithParameters,
  licenseToCompanyExcel: REQUEST_TEMPLATES(REPORT_API.LICENSE_TO_COMPANY_EXCEL).downloadFile,
  budgetList: REQUEST_TEMPLATES(REPORT_API.BUDGET).getWithParameters,
  budgetExcel: REQUEST_TEMPLATES(REPORT_API.BUDGET_EXCEL).downloadFile,
};

export const Account = {
  login: REQUEST_TEMPLATES(ACCOUNT_API.LOGIN).create,
  verifyOtp: REQUEST_TEMPLATES(ACCOUNT_API.VERIFY_OTP).create,
  logout: REQUEST_TEMPLATES(ACCOUNT_API.LOGOUT).getWithParameters,
}

export const Permission = {
  list: REQUEST_TEMPLATES(PERMISSION_API.LIST).create,
}